import { cn } from '@core-utils/cn';
import { forwardRef } from 'react';

import { Label, LabelProps } from '../Label';
import style from './Form.module.scss';

const FormLabel = forwardRef<HTMLLabelElement, LabelProps>(function FormLabel(
    { className, ...props },
    ref,
) {
    return <Label className={cn(style.FormLabel, className)} {...props} />;
});

export { FormLabel };
